import styled from 'styled-components'
import variables, { colors, device } from 'Styled/variables'
import { PopupButton } from '@typeform/embed-react'
import { Tabs } from 'antd'

interface Props {
  approved?: boolean
}

export const BtnContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledPopupButton = styled(PopupButton)`
  background-color: ${colors.mainText} !important;
  cursor: pointer;
  position: fixed;
  top: 30%;
  right: 0px;
  transform: rotate(-90deg);
  transform-origin: bottom right;
  z-index: 1000;
  width: 200px;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: ${colors.white};
  border-radius: 8px 8px 0 0;
  border: 0;
  outline: none;
  text-decoration: none;
  font-size: ${variables.fontSize18};
  font-family: Helvetica, Arial, sans-serif;
`

export const StyledShareFeedback = styled.div`
  transform: rotate(90deg);
  width: 24px;
  height: 24px;
  font-size: ${variables.fontSize24};
  margin-right: 12px;
  position: relative;
  order: -1;
`
export const ShareFeedbackText = styled.span`
  font-family: Helvetica, Arial, sans-serif;
  font-size: ${variables.fontSize18};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Card = styled.div`
  width: 100%;
  padding-bottom: 30px;
  @media ${device.smallScreen} {
    background-color: ${colors.white};
  }
`

export const StyledList = styled.ul`
  width: 100%;
  padding-left: 0px;
`
export const StyledNoData = styled.div`
  text-align: center;
`

export const StyledTabsWrapper = styled.div`
  .ant-tabs-nav-more > span {
    display: none;
  }
  .ant-tabs-tab {
    padding: 10px 0px;
    @media ${device.smallScreen} {
      padding: 12px 0px;
    }
  }

  .ant-tabs-nav-list {
    border-bottom: 1px solid #eeeeee;
  }
  .ant-tabs-card > .ant-tabs-nav::before {
    display: none;
  }
  .ant-tabs-card .ant-tabs-tab,
  [data-theme='compact'] .card-container > .ant-tabs-card .ant-tabs-tab {
    background: transparent;
    border-color: transparent;
  }
  .ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-nav-list {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after {
    box-shadow: none !important;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin: 0;
  }
`

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav-list {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::before {
    box-shadow: none !important;
  }
  .ant-tabs-top > .ant-tabs-nav .ant-tabs-nav-wrap::after {
    box-shadow: none !important;
  }
  padding-left: 0;
  @media ${device.smallScreen} {
    padding-left: 24px;
    padding-right: 24px;
  }
  .ant-tabs-tab-btn {
    padding: 0px 8px 0 16px;
    @media ${device.smallScreen} {
      padding: 0px 16px 0 24px;
    }
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: ${variables.fontSize14};
    line-height: 21px;
  }
  .ant-tabs-ink-bar {
    background: ${colors.green};
  }
  .ant-tabs-nav {
    margin-bottom: 31px;
    @media ${device.smallScreen} {
      margin-bottom: 24px;
    }
  }
`
export const StyledTabsItem = styled(Tabs.TabPane)`
  color: ${colors.mainText};
`

export const TabName = styled.span`
  color: ${colors.mainText};
  margin-right: 8px;
`

export const Number = styled.span`
  color: ${(props: Props) =>
    props.approved ? colors.green : colors.greyTextBlackBg};
`
export const RoundBtn = styled.button`
  background: ${colors.white};
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  border-radius: 24px;
  min-width: 40px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
`
